import { render, staticRenderFns } from "./ChangeInscription.vue?vue&type=template&id=008746ec"
import script from "./ChangeInscription.vue?vue&type=script&lang=js"
export * from "./ChangeInscription.vue?vue&type=script&lang=js"
import style0 from "./ChangeInscription.vue?vue&type=style&index=0&id=008746ec&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../frontend/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports